import styled from 'styled-components';

export const TopCarouselWrapper = styled.div`
  margin: 0 auto;
  width: 60%;
  /* background-image:url("https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fworkshop_top_white.jpg?alt=media&token=c65e38bc-7581-4729-aa8c-90ba2c639c3f"); */
  background-image: url(${(props) => props.img});
  height: 400px;

  background-size: cover;
  background-position: 50%;
  /* background: white; */
  padding: 50px 10px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.2);
  @media (max-width: 768px) {
    padding: 20px 0px;
    height: 250px;
    width: 95%;
  }
`;

export const TopCarouselColumn = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  > div {
    width: 70%;
    margin: 20px;
  }

  @media (max-width: 768px) {
    > div {
      width: 75%;
      margin: 20px;
    }
  }
`;
